const stemiColumns = [
  "Olympiad Name",
  "Olympiad Date",
  "Science Club Member",
  "Sector",
  "Category",
  "Sub Category",
  "Learner Identifier",
  "Learner Race",
  "Learner Gender",
  "Learner Disability",
  "School Name",
  "Province",
  "District",
  "School Type",
  "School Quintile",
  "Learner Grade",
  "Round",
  "Learner Result",
];

export default stemiColumns;
